import styles from '@styles/TermsAndConditions.module.css'

const TermsAndConditions = () => {
  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.termsTitle}>Términos y Condiciones de Óptica Natalú</h1>
      <ol className={styles.termsList}>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Información General</h2>
          <p className={styles.termsText}>
            Óptica Natalú opera en Colombia y ofrece monturas y lentes a través de su página web.
            Al realizar una compra, el cliente acepta los términos y condiciones aquí descritos, 
            los cuales pueden ser actualizados en cualquier momento.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Alcance de los Servicios</h2>
          <p className={styles.termsText}>
            Óptica Natalú garantiza que todos los productos ofrecidos en su sitio web cumplen con los 
            estándares de calidad. Sin embargo, los tiempos de entrega y las políticas aplicables pueden 
            variar según el tipo de producto y la región del cliente.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Garantías y Responsabilidades</h2>
          <ul className={styles.termsUl}>
            <li className={styles.termsLi}>
              Formulación de lentes: Las gafas elaboradas con fórmulas suministradas por terceros 
              (diferentes a Óptica Natalú) no cuentan con garantía ni responsabilidad alguna por parte de la óptica.
            </li>
            <li className={styles.termsLi}>
              Revisión del producto: El cliente debe revisar los productos al momento de recibirlos. 
              Si presentan defectos de fabricación, podrá solicitar un cambio inmediato. No se aceptan devoluciones 
              o reclamos después de este momento.
            </li>
            <li className={styles.termsLi}>
              Mal uso o daño: Óptica Natalú no se responsabiliza por daños derivados del mal uso, manejo inadecuado o accidentes.
            </li>
            <li className={styles.termsLi}>
              Productos personalizados: Los productos elaborados bajo fórmula personalizada solo serán garantizados si 
              la fórmula fue proporcionada por Óptica Natalú.
            </li>
          </ul>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Cambios y Devoluciones</h2>
          <ul className={styles.termsUl}>
            <li className={styles.termsLi}>
              Los cambios o devoluciones serán aceptados únicamente en los casos en que el producto presente defectos comprobables al momento de la entrega.
            </li>
            <li className={styles.termsLi}>
              En los casos donde el error sea atribuible a Óptica Natalú, se procederá con una pronta solución en la cual queden satisfechos ambas partes.
            </li>
          </ul>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Tiempos de Entrega</h2>
          <p className={styles.termsText}>
            Los tiempos de entrega varían según el tipo de producto seleccionado y la región del cliente. Cualquier demora 
            será comunicada oportunamente, y Óptica Natalú hará lo posible por resolver cualquier inconveniente relacionado con el envío.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Métodos de Pago</h2>
          <p className={styles.termsText}>
            Se aceptan transferencias bancarias como método de pago principal. El pago debe realizarse en su totalidad antes del envío del producto.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Servicios Adicionales</h2>
          <p className={styles.termsText}>
            Óptica Natalú ofrece ajustes y reparaciones de monturas en casos específicos y dependiendo de la ubicación del cliente. 
            Estos servicios no están garantizados en todas las regiones.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Protección de Datos</h2>
          <p className={styles.termsText}>
            Óptica Natalú recopila y protege los datos personales de sus clientes de acuerdo con la Ley 1581 de 2012. 
            Para más información sobre el manejo de datos, consulte nuestra Política de Privacidad.
          </p>
        </li>
        <li className={styles.termsItem}>
          <h2 className={styles.termsSubtitle}>Contacto y Resolución de Conflictos</h2>
          <ul className={styles.contactList}>
            <li className={styles.contactItem}>Redes sociales oficiales de Óptica Natalú</li>
            <li className={styles.contactItem}>Formulario de contacto disponible en la página web</li>
          </ul>
        </li>
      </ol>
    </div>
  )
}

export default TermsAndConditions
